<template>
  <div>
    <v-text-field
        :disabled="isDisabled"
        :required="required"
        :class="cssClass"
        :id="clef"
        :ref="clef"
        :label="text"
        v-bind:value="value"
        :loading="loading"
        autocomplete="address"
        :rules="rules.adresse"
        @change="updateFromManualEntry"></v-text-field>
  </div>
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex'

  export default {
    props: {
      value: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: 'Chercher'
      },
      clef: "",
      disabled: {
        type: Boolean,
        default: false
      },
      required: {
        type: Boolean,
        default: false
      },
			cssClass: {
        type: String,
        default: ''
			},
    },
    data () {
      return {
        loading: false,
        rules: {
          adresse: [(v) => this.clef === "contactDeBase" || this.valid && !!v || "L'adresse doit être validée par CanadaPost"],
        },
        loadError: false,
        dataDisabled: false,
        // Valide si la dernière modification viens de Canada Post et pas d'une saisie utilisateur.
        valid: this.value != null && this.value !== '',
      }
    },
    mounted () {
      if (window.pca !== undefined) {
        this.initCanadaPostFields()
      } else {
        this.initialiseModule({ component: this, callback: this.initCanadaPostFields})
      }
    },
    computed: {
      ...mapState('CanadaPost', ['address']),
      ...mapGetters('CanadaPost', ['getApiCssUrl', 'getApiJsUrl', 'getApiKey', 'oneLineAddress']),
      isDisabled() {
        return this.disabled || this.dataDisabled
			}
    },
    methods: {
      ...mapActions('CanadaPost', ['initialiseModule']),
      initCanadaPostFields () {
        const self = this
        const fields = [
          { element: self.clef, field: 'chercher', mode: pca.fieldMode.SEARCH }
        ]
        const options = {
          key: this.getApiKey,
          autoSearch: true,
          languagePreference: 'fra',
          culture: 'fr-ca'
        }
        const control = new pca.Address(fields, options)
        control.listen('populate', function (address) {
          self.loading = true
					self.dataDisabled = true
          self.$emit("updateAdresse", address)
          self.loading = false
					self.dataDisabled = false

          self.$nextTick(() => {
            self.valid = true
            self.$forceUpdate()
          })
        })
      },
      setFocusOnSearch () {
        this.$nextTick(() => {
          this.$refs.eudopcasearch.focus()
        })
      },
      updateFromManualEntry (event) {
        this.valid = false
        this.$emit('manualEntry', event);
      }
    }
  }
</script>

<style scoped>
</style>
